// extracted by mini-css-extract-plugin
export default {"root":"ujKg9ZDsPja8XCqXO5JS","marks":"sKPNeYs2usaftqDIR2ww","placeHolderShimmer":"tIcjxrnI4Et2rRYltdaJ"};